<template>
  <div>
    <el-select
      v-model="shop_id"
      :placeholder="placeholder + ''"
      value-key="id"
      filterable
      remote
      :remote-method="getShop"
      :clearable="clearable"
      @change="changeShop"
      ref="agentSelect"
      @hook:mounted="cancalReadOnly"
      @visible-change="cancalReadOnly"
    >
      <el-option
        v-for="item in shop_list"
        :key="item.id"
        :label="item.shop_name"
        :value="item.id"
        @click.native="shopChange(item)"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "输入店铺名称/联系电话",
    },
    info: {
      type: String,
      default: "",
    },
    condition: {
      type: Object,
      default: () => {
        return {};
      },
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    info: {
      immediate: true,
      handler(nv, ov) {
        this.selected_shop = nv;
      },
    },
  },
  data() {
    return {
      shop_list: [],
      selected_shop: "",
      shop_id: "",
    };
  },
  methods: {
    changeShop() {
      this.$emit("update:shopid", this.shop_id);
    },
    shopChange(item) {
      this.$emit("change", item);
    },
    getShop(query) {
      this.shop_list = [];
      const numberReg = /^\d/;
      if (query && typeof query == "string") {
        let data = {
          currentPage: 1,
          pageSize: 10,
          ...this.condition,
        };
        numberReg.test(query)
          ? (data.contact_phone = query)
          : (data.shop_name = query);
        let url = "/user/shop/queryManagerListPage";
        this.$axios
          .get(url, {
            params: data,
          })
          .then((res) => {
            this.shop_list = res.data.data.rows;
            this.$emit("search", res.data.data.rows);
          });
      }
    },
    setValue(item) {
      this.shop_list = [item];
      this.shop_id = item.id;
    },
    clear() {
      this.shop_list = [];
      this.shop_id = "";
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const Selects = this.$refs;
          if (Selects.agentSelect) {
            const input =
              Selects.agentSelect.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
